module.exports = __webpack_public_path__ + "img/goldregen-2020-120.706816ba.jpg";